// Native details provides a usable menu before JavaScript loads.
document.querySelectorAll('[data-ls-menu]').forEach((menu) => {
  const summary = menu.querySelector('summary');
  menu.addEventListener('click', (event) => {
    if (event.target.closest('a')) menu.open = false;
  });
  menu.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      summary.focus();
    }
  });
  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
